// Extend Window interface to include custom properties
declare global {
  interface Window {
    __sstLoaderInserted?: boolean;
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const appRegion = config.public.appRegion;
  const appEnv = config.public.appEnvironment;
  const gtmId = config.public.gtmId;

  if (appEnv === 'local') return;

  if (typeof window !== 'undefined' && window.__sstLoaderInserted) {
    return;
  }

  // Defer GTM loading until after page is interactive
  if (import.meta.client) {
    // Use requestIdleCallback to load GTM when browser is idle
    const loadGTM = () => {
      if (window.__sstLoaderInserted) return;
      window.__sstLoaderInserted = true;

      // Initialize dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

      if (appRegion === 'NL') {
        const script = document.createElement('script');
        script.async = true;
        script.src =
          'https://load.sst.toolstation.nl/eeayqbogf.js?4dt6a=DwNSJSU0TDUiVFYzOSlHE1tVQVNXHQ9YEggADgINABEPCAFMHxU%3D';
        document.head.appendChild(script);

        // Add noscript fallback
        // const noscript = document.createElement('noscript');
        // const iframe = document.createElement('iframe');
        // iframe.src = 'https://load.sst.toolstation.nl/ns.html?id=GTM-PD39QHP';
        // iframe.height = '0';
        // iframe.width = '0';
        // iframe.style.display = 'none';
        // iframe.style.visibility = 'hidden';
        // noscript.appendChild(iframe);
        // document.body.prepend(noscript);
      }

      if (appRegion === 'BE') {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
        document.head.appendChild(script);
      }
    };

    // Load GTM after page is interactive using requestIdleCallback
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadGTM, { timeout: 2000 });
    } else {
      // Fallback for browsers without requestIdleCallback
      setTimeout(loadGTM, 2000);
    }
  }
});
